import React, { useState } from 'react';
import BankPay from './BankPay.js';
import BankCurrent from './BankCurrent.js';
import Visa from './Visa.js';
import TransactionHistory from './TransactionHistory.js';
import Web3FX from '../Web3FX.js'; // One level up

const PayTabs = ({
  connectWallet,
  walletAddress,
  web3payContract,
  contractMode,
  contractData,
  balances,
  refreshBalances,
  contractTransactions
}) => {
  const [activeTab, setActiveTab] = useState('bankPay');

  const tabButtonStyle = (isActive) => ({
    background: isActive ? '#FFD700' : 'transparent',
    color: isActive ? 'black' : '#FFD700',
    border: '2px solid #FFD700',
    padding: '10px 20px',
    margin: '0 5px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
  });

  return (
    <div className="pay-tabs">
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '30px',
        flexWrap: 'wrap',
        gap: '10px',
      }}>
        <button
          style={tabButtonStyle(activeTab === 'bankPay')}
          onClick={() => setActiveTab('bankPay')}
        >
          BankSystem Pay
        </button>
        <button
          style={tabButtonStyle(activeTab === 'current')}
          onClick={() => setActiveTab('current')}
        >
          Current Account
        </button>
        <button
          style={tabButtonStyle(activeTab === 'visa')}
          onClick={() => setActiveTab('visa')}
        >
          Visa
        </button>
        <button
          style={tabButtonStyle(activeTab === 'history')}
          onClick={() => setActiveTab('history')}
        >
          Transaction History
        </button>
        <button
          style={tabButtonStyle(activeTab === 'web3fx')}
          onClick={() => setActiveTab('web3fx')}
        >
          Web3FX Swaps
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'bankPay' && (
          <BankPay
            walletAddress={walletAddress}
            web3payContract={web3payContract}
            contractMode={contractMode}
            contractData={contractData}
            balances={balances}
            refreshBalances={refreshBalances}
          />
        )}
        {activeTab === 'current' && (
          <BankCurrent
            walletAddress={walletAddress}
            web3payContract={web3payContract}
            contractMode={contractMode}
            contractData={contractData}
            balances={balances}
            refreshBalances={refreshBalances}
            contractTransactions={contractTransactions}
          />
        )}
        {activeTab === 'visa' && <Visa />}
        {activeTab === 'history' && (
          <TransactionHistory
            walletAddress={walletAddress}
            web3payContract={web3payContract}
            contractMode={contractMode}
            contractTransactions={contractTransactions}
            refreshTransactions={refreshBalances}
          />
        )}
        {activeTab === 'web3fx' && <Web3FX />}
      </div>
    </div>
  );
};

export default PayTabs;
